import * as React from "react"

import { Svg } from "styleguide/components"
import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconDownload = ({
  title = "Download",
  color = "darkerRed",
  viewBoxWidth = 16,
  viewBoxHeight = 20,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <path
      d="M7 0h2v16.5l5.8-5.8L16 12l-8 8-8-8 1.3-1.3L7 16.6z"
      fill={uiColorToBaseColor(color)}
      fillRule="evenodd"
    />
  </Svg.Icon>
)

export default IconDownload
